import { render, staticRenderFns } from "./ReducedVat.vue?vue&type=template&id=ab55753e&"
import script from "./ReducedVat.vue?vue&type=script&lang=js&"
export * from "./ReducedVat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports